"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SERVICE_1_1_VIDEO_CREATION_HOSTING", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SERVICE_1_1_VIDEO_CREATION_HOSTING;
  }
});
Object.defineProperty(exports, "SERVICE_CALCULATED_PROPERTIES", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SERVICE_CALCULATED_PROPERTIES;
  }
});
Object.defineProperty(exports, "SERVICE_CALLING", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SERVICE_CALLING;
  }
});
Object.defineProperty(exports, "SERVICE_CANNED_SNIPPETS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SERVICE_CANNED_SNIPPETS;
  }
});
Object.defineProperty(exports, "SERVICE_CONVERSATION_ROUTING", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SERVICE_CONVERSATION_ROUTING;
  }
});
Object.defineProperty(exports, "SERVICE_CONVERSATIONAL_BOTS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SERVICE_CONVERSATIONAL_BOTS;
  }
});
Object.defineProperty(exports, "SERVICE_CONVERSATIONS_INBOX", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SERVICE_CONVERSATIONS_INBOX;
  }
});
Object.defineProperty(exports, "SERVICE_CUSTOM_REPORTING", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SERVICE_CUSTOM_REPORTING;
  }
});
Object.defineProperty(exports, "SERVICE_CUSTOM_SUPPORT_FORM_FIELDS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SERVICE_CUSTOM_SUPPORT_FORM_FIELDS;
  }
});
Object.defineProperty(exports, "SERVICE_CUSTOMER_FEEDBACK", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SERVICE_CUSTOMER_FEEDBACK;
  }
});
Object.defineProperty(exports, "SERVICE_CUSTOMER_SERVICE_AUTOMATION", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SERVICE_CUSTOMER_SERVICE_AUTOMATION;
  }
});
Object.defineProperty(exports, "SERVICE_EMAIL_CHAT_TO_TICKET", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SERVICE_EMAIL_CHAT_TO_TICKET;
  }
});
Object.defineProperty(exports, "SERVICE_EMAIL_SEQUENCES", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SERVICE_EMAIL_SEQUENCES;
  }
});
Object.defineProperty(exports, "SERVICE_EMAIL_TEMPLATES", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SERVICE_EMAIL_TEMPLATES;
  }
});
Object.defineProperty(exports, "SERVICE_GOALS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SERVICE_GOALS;
  }
});
Object.defineProperty(exports, "SERVICE_HUBSPOT_BRANDING_REMOVED", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SERVICE_HUBSPOT_BRANDING_REMOVED;
  }
});
Object.defineProperty(exports, "SERVICE_KNOWLEDGE_BASE", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SERVICE_KNOWLEDGE_BASE;
  }
});
Object.defineProperty(exports, "SERVICE_LIVE_CHAT", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SERVICE_LIVE_CHAT;
  }
});
Object.defineProperty(exports, "SERVICE_MEETING_SCHEDULING", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SERVICE_MEETING_SCHEDULING;
  }
});
Object.defineProperty(exports, "SERVICE_MULTIPLE_CURRENCIES", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SERVICE_MULTIPLE_CURRENCIES;
  }
});
Object.defineProperty(exports, "SERVICE_MULTIPLE_TICKET_PIPELINES", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SERVICE_MULTIPLE_TICKET_PIPELINES;
  }
});
Object.defineProperty(exports, "SERVICE_PHONE_SUPPORT", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SERVICE_PHONE_SUPPORT;
  }
});
Object.defineProperty(exports, "SERVICE_PLAYBOOKS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SERVICE_PLAYBOOKS;
  }
});
Object.defineProperty(exports, "SERVICE_REPORTING_DASHBOARDS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SERVICE_REPORTING_DASHBOARDS;
  }
});
Object.defineProperty(exports, "SERVICE_SALESFORCE_INTEGRATION", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SERVICE_SALESFORCE_INTEGRATION;
  }
});
Object.defineProperty(exports, "SERVICE_SINGLE_SIGN_ON", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SERVICE_SINGLE_SIGN_ON;
  }
});
Object.defineProperty(exports, "SERVICE_TEAM_EMAIL", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SERVICE_TEAM_EMAIL;
  }
});
Object.defineProperty(exports, "SERVICE_TEAMS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SERVICE_TEAMS;
  }
});
Object.defineProperty(exports, "SERVICE_TICKETING", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SERVICE_TICKETING;
  }
});

var _HubSpotFeature = require("../HubSpotFeature");


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/groupTags/hubspotFeatures/Service.js
// module id = 724
// module chunks = 209 210 211 212